import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';

/**
 * Theme Context'i kullanmak için custom hook
 * @throws Error - ThemeProvider olmadan kullanılırsa hata fırlatır
 */
export const useTheme = () => {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error('useTheme hook\'u ThemeProvider içinde kullanılmalıdır');
  }

  return context;
};
